import { Fragment, useMemo } from "react";

import { Box } from "@mui/material";

import { splitByMatches } from "./HighlightedText.utils";

interface Props {
  text: string | null | undefined;
  /** Literal term to highlight; empty renders the text unhighlighted. */
  searchTerm: string;
}

/**
 * Renders text with every case-insensitive occurrence of the search term wrapped in a
 * yellow <mark>. Emits inline nodes only, so parent typography (variant, whiteSpace)
 * applies unchanged.
 */
export function HighlightedText({ text, searchTerm }: Props) {
  const segments = useMemo(() => splitByMatches(text ?? "", searchTerm), [text, searchTerm]);

  return (
    <>
      {segments.map((segment, index) =>
        segment.highlighted ? (
          <Box key={index} component="mark" sx={{ bgcolor: (theme) => theme.palette.fsw.yellow, color: "inherit" }}>
            {segment.text}
          </Box>
        ) : (
          <Fragment key={index}>{segment.text}</Fragment>
        )
      )}
    </>
  );
}
